import {
  NeedViewDto,
  NeedsHistoryEntryDto,
  NeedsActionDto,
  NeedUpdateDto,
  NeedsResourceDetailsDto,
} from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum NeedEventTypes {
  NEED_UPSERTED = '[Need] Upserted',
  NEED_HISTORY_ENTRY_UPSERTED = '[Need History Entry] Upserted',
  NEED_RESOURCE_REFERRAL_UPSERTED = '[Need Resource Referral] Created',
  NEED_DELETED = '[Need] Deleted',
}

/**
 * Payloads
 */
export interface NeedUpsertedEventPayload {
  needView: NeedViewDto;
}
export interface NeedHistoryEntryUpsertedEventPayload {
  needsHistoryEntry: NeedsHistoryEntryDto;
  needAction?: NeedsActionDto;
  needUpdate?: NeedUpdateDto;
  resourceDetails?: NeedsResourceDetailsDto;
}
export interface NeedDeletedEventPayload {
  needId: number;
}

/**
 * Events
 */
export class NeedHistoryEntryUpsertedEvent {
  readonly type = NeedEventTypes.NEED_HISTORY_ENTRY_UPSERTED;

  constructor(public payload: NeedHistoryEntryUpsertedEventPayload) {}
}

export class NeedDeletedEvent {
  readonly type = NeedEventTypes.NEED_DELETED;

  constructor(public payload: NeedDeletedEventPayload) {}
}
